import React, { useEffect, useState, useRef } from 'react'
import CountUp from 'react-countup';
import { liteClient as algoliasearch } from 'algoliasearch/lite';
import { InstantSearch, ClearRefinements, Hits, useSearchBox, useHits } from 'react-instantsearch';
import ModalLayout from '../../Componments/Frontend/Common/ModalLayout';
import { getImages } from '../../Componments/Frontend/const';

const searchClient = algoliasearch(
    'E8DWRSZE4Q',
    '2e1db67e90eec79f4968c0073885c388'
);

const CustomSearchBox = (props) => {
    const {
        query,
        refine,
        clear,
        currentRefinement = "",
    } = useSearchBox(props);
    const [isFocused, setIsFocused] = useState(false);
    const [selectedHit, setSelectedHit] = useState("");
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => {
        setTimeout(() => setIsFocused(false), 200);
    };
    const handleHitClick = (hit) => {
        setSelectedHit(hit.vehicle_name);
        refine(hit.vehicle_name);
        props.onHitClick(hit);
    };

    const { items, results, banner, sendEvent } = useHits(props);

    useEffect(() => {
        //console.log(items,results);
        if (items.length === 1) {
            setSelectedHit(items[0].vehicle_name);
            //refine(hit.vehicle_name);
            props.onHitClick(items[0]);
        }
    }, [items, results]);


    return (
        <>
            <div className='form-group'>
                <div className="custom-searchbox position-relative">
                    <input
                        type='text'
                        value={selectedHit || currentRefinement || ''}
                        onChange={event => {
                            refine(event.currentTarget.value);
                            setSelectedHit(event.currentTarget.value);
                        }}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        name="vehicle"
                        className="form-control"
                        placeholder='Enter VIN or Year Make and Model'
                    />
                    {isFocused && (
                        <Hits hitComponent={({ hit }) => (
                            <div className="hit" onClick={() => handleHitClick(hit)}>
                                <p>{hit.vehicle_name}</p>
                            </div>
                        )} />
                    )}
                </div>
            </div>
            <div className='form-group'>
                <button className='btn-black-theme lg-btn w-100 text-uppercase' type='button' onClick={() => { props.onHitClick(items[0]); }}>Get Offer</button>
            </div>
        </>
    );
}

const TradeSellLuxuryCar = () => {
    const [trigger, setTrigger] = useState(false);
    const handleScrollEvent = async () => {
        const element = await document.getElementById("data");
        const elementPosition = await element.getBoundingClientRect().top;
        if (window.pageYOffset > elementPosition) {
            setTrigger(true);
        }
    };
    const increment = () => {
        console.log("Element is in view!");
    };
    const registerEvent = () => {
        document.addEventListener("scroll", handleScrollEvent);
    };
    const unRegisterEvent = () => {
        document.removeEventListener("scroll", handleScrollEvent);
    };
    useEffect(() => {
        if (trigger) {
            increment();
        }
        registerEvent();
        return () => {
            unRegisterEvent();
        };
    }, [trigger]);
    const [openAppraiseCar, setOpenAppraiseCar] = useState(false);
    const [inputValue, setInputValue] = useState({
        form1: '',
        form2: '',
        form3: '',
    });

    const getOfferModal = () => {
        setOpenAppraiseCar(true);
        document.body.classList.add('overflow-body');
    }
    const closeGetOfferModal = () => {
        setOpenAppraiseCar(false);
        document.body.classList.remove('overflow-body');
    }

    const formikRef = useRef(null);

    const handleSearchClick = (hit) => {
        formikRef.current.setFieldValue("vehicle", hit.vehicle_name);
        formikRef.current.setFieldValue("year", hit.year_is);
        formikRef.current.setFieldValue("make", hit.make_ss);
        formikRef.current.setFieldValue("model", hit.model_ss);
        formikRef.current.setFieldValue("trim", hit.trim_ss);
        console.log(hit, formikRef.current.values);
        setOpenAppraiseCar(true);
        document.body.classList.add('overflow-body');
    }
    return (
        <>
            <section className='tslc-wrap'>
                <section className='fullh-hero-wrap hero-shadow position-relative mob-pos-inherit'>
                    <div className='banner-pos'>
                        <div className='container'>
                            <div className='d-flex align-items-center justify-content-between tslc-banner-flex'>
                                <div>
                                    <div className='banner-title text-start wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">
                                        <em><span className='text-orange'>Sell Your Car</span> <br />
                                        <span className='font-0-6em'>For Top Dollar</span></em>
                                    </div>
                                </div>
                                <div className='eca-get-offer custom-form wow fadeInRight' data-wow-delay="0.6s">
                                    <div className='md-title text-center font-1-8em mb-4'>Get an instant offer for <br/>your car now!</div>
                                    <div className='eca-banner-form text-start'>
                                    <InstantSearch indexName="taxonomy_vins" searchClient={searchClient}>
                                        <CustomSearchBox onHitClick={handleSearchClick} />
                                    </InstantSearch>
                                    </div>
                                    <div className='mt-5 text-center sm-title'>
                                        <img className='tslc-icon' src={getImages('local-phone-material.svg')} /> &nbsp;&nbsp;
                                        <span className='text-orange me-4'>
                                            Call Us
                                        </span>
                                        (561) 266-000
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='how-works-wrap'>
                    <div className='container'>
                        <div className='md-title font-2-2em fw-900 text-uppercase mb-4 wow fadeInDown' data-wow-delay="0.2s">How it works?</div>
                        <div className='row'>
                            <div className='col-xl-6 col-lg-5 hw-left pe-5'>
                                <div className='d-flex align-items-center hw-flex wow fadeInLeft' data-wow-delay="0.4s">
                                    <div className='hw-circle font-1-8em fw-700 text-white'>1</div>
                                    <div className='ps-3'>
                                        <div className='sm-title fw-700 font-1-2em mb-1'>Enter your vehicle Info</div>
                                        <p className='text-lgray fw-500'>With just your VIN or year make model & trim we'll get the process started for you. We're here to make this simple.
                                        </p>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center hw-flex wow fadeInLeft' data-wow-delay="0.6s">
                                    <div className='hw-circle font-1-8em fw-700 text-white'>2</div>
                                    <div className='ps-3'>
                                        <div className='sm-title fw-700 font-1-2em mb-1'>Get your Offer</div>
                                        <p className='text-lgray fw-500'>Our team will review your vehicle's demand in the current marketplace and give you the most competitive cash offer possible.</p>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center hw-flex wow fadeInLeft' data-wow-delay="0.8s">
                                    <div className='hw-circle font-1-8em fw-700 text-white'>3</div>
                                    <div className='ps-3'>
                                        <div className='sm-title fw-700 font-1-2em mb-1'>Receive your cash</div>
                                        <p className='text-lgray fw-500'>Just bring your vehicle by our showroom, or arrange for pickup and we'll cut you a check that same day. Easy & hassle free.</p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-xl-6 col-lg-7 hw-right wow fadeInRight' data-wow-delay="1s">
                                <div className='row g-5'>
                                    <div className='col-md-6'>
                                        <div className='hwr-box d-flex align-items-center'>
                                            <div className='hwr-icon'>
                                                <img src={getImages('attach-money-material.svg')} />
                                            </div>
                                            <div className='hwr-title ps-4'>Get Top Dollar for your Vehicle</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='hwr-box d-flex align-items-center'>
                                            <div className='hwr-icon'>
                                                <img src={getImages('ion-android-checkmark-circle-ionicons.svg')} />
                                            </div>
                                            <div className='hwr-title ps-4'>Sell or Trade your Vehicle</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='hwr-box d-flex align-items-center'>
                                            <div className='hwr-icon'>
                                                <img src={getImages('icon-star1.svg')} />
                                            </div>
                                            <div className='hwr-title ps-4'>Easy and Fast Process</div>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='hwr-box d-flex align-items-center'>
                                            <div className='hwr-icon'>
                                                <img src={getImages('icon-world-copy.svg')} />
                                            </div>
                                            <div className='hwr-title ps-4'>Satisfaction Guaranteed</div>
                                        </div>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center justify-content-between mt-5 get-offer-block'>
                                    <div className='sm-title text-uppercase fw-600'>GET AN OFFER <span className='text-orange'>SAME DAY</span> <br />FOR YOUR CAR NOW!</div>
                                    <div className='w-50 ps-4'>
                                        <button type='button' className='btn-orange-theme text-uppercase w-100' onClick={getOfferModal}>Get Offer</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='eca-count-wrap' id="data">
                    <div className='container'>
                        <div className='eca-count-box'>
                            <div className='row reliable-block'>
                                <div className='col-lg-3 col-md-6 py-1'>
                                    <div className='reliable-value mb-4'>
                                        <CountUp start={0} end={30} duration={3}></CountUp>+
                                    </div>
                                    <div className='reliable-label'>Years of Experience</div>
                                </div>
                                <div className='col-lg-3 col-md-6 py-1'>
                                    <div className='reliable-value mb-4'>
                                        {trigger ? (
                                            <>
                                                <CountUp start={0} end={4200} duration={3}></CountUp>
                                            </>
                                        ) : (
                                            <div>0</div>
                                        )}
                                    </div>
                                    <div className='reliable-label'>Vehicles Bought</div>
                                </div>
                                <div className='col-lg-3 col-md-6 py-1'>
                                    <div className='reliable-value mb-4'>
                                        {trigger ? (
                                            <>
                                                <CountUp start={0} end={3500} duration={3}></CountUp>
                                            </>
                                        ) : (
                                            <div>0</div>
                                        )}
                                    </div>
                                    <div className='reliable-label'>Satisfied Customers</div>
                                </div>
                                <div className='col-lg-3 col-md-6 py-1'>
                                    <div className='reliable-value mb-4'>
                                        {trigger ? (
                                            <>
                                                <CountUp start={0} end={140} duration={3}></CountUp>
                                            </>
                                        ) : (
                                            <div>0</div>
                                        )}
                                    </div>
                                    <div className='reliable-label'>Cities Served</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='recently-vehicles-wrap'>
                    <div className='container'>
                        <div className='lg-title text-white text-start mb-4 font-bold'>Recently purchased vehicles</div>
                        <div className='row wow fadeInUp' data-wow-delay="0.4s">
                            <div className='col-lg-3 col-md-6 col-6 mb-3'>
                                <div className='rpv-box'>
                                    <div className='rpv-img'>
                                        <img src={getImages('rpv-img1.webp')} />
                                    </div>
                                    <div className='rpv-content'>
                                        <div className='d-flex align-items-center mb-2 justify-content-between'>
                                            <div className='sm-title fw-900 font-1-2em text-orange'>Billy P</div>
                                            <div className='sold-btn d-inline-block text-uppercase'>Sold</div>
                                        </div>
                                        <div className='rpv-address text-white'>New York, NY</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-6 col-6 mb-3'>
                                <div className='rpv-box'>
                                    <div className='rpv-img'>
                                        <img src={getImages('rpv-img2.webp')} />
                                    </div>
                                    <div className='rpv-content'>
                                        <div className='d-flex align-items-center mb-2 justify-content-between'>
                                            <div className='sm-title fw-900 font-1-2em text-orange'>Michael J</div>
                                            <div className='sold-btn d-inline-block text-uppercase'>Sold</div>
                                        </div>
                                        <div className='rpv-address text-white'>Springfield, NY</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-6 col-6 mb-3'>
                                <div className='rpv-box'>
                                    <div className='rpv-img'>
                                        <img src={getImages('rpv-img3.webp')} />
                                    </div>
                                    <div className='rpv-content'>
                                        <div className='d-flex align-items-center mb-2 justify-content-between'>
                                            <div className='sm-title fw-900 font-1-2em text-orange'>Karol M</div>
                                            <div className='sold-btn d-inline-block text-uppercase'>Sold</div>
                                        </div>
                                        <div className='rpv-address text-white'>Sunrise, NJ</div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-3 col-md-6 col-6 mb-3'>
                                <div className='rpv-box'>
                                    <div className='rpv-img'>
                                        <img src={getImages('rpv-img1.webp')} />
                                    </div>
                                    <div className='rpv-content'>
                                        <div className='d-flex align-items-center mb-2 justify-content-between'>
                                            <div className='sm-title fw-900 font-1-2em text-orange'>Jerry S</div>
                                            <div className='sold-btn d-inline-block text-uppercase'>Sold</div>
                                        </div>
                                        <div className='rpv-address text-white'>New York, NY</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                <section className='logos-wrap'>
                    <div class="logos-slider">
                        <div class="logos-slide-track">
                            <div className='logos-slide'>
                                <img src={getImages('logo-benz.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('porsche-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('maserati-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('ferrari-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('bmw-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('audi.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('logo-lambo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('landrover-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('logo-benz.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('porsche-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('maserati-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('ferrari-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('bmw-logo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('audi.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('logo-lambo.webp')} alt='' />
                            </div>
                            <div className='logos-slide'>
                                <img src={getImages('landrover-logo.webp')} alt='' />
                            </div>
                        </div>
                    </div>
                </section>
                <section className='get-offer-wrap wow fadeInUp' data-wow-delay="0.4s">
                    <div className='container'>
                        <div className='d-flex align-items-center justify-content-between pl-flex'>
                            <div className='md-title font-1-8em'>Find out what your vehicle is worth?</div>
                            <div className='d-flex get-offer-form w-50  text-start'>
                                <InstantSearch indexName="taxonomy_vins" searchClient={searchClient} >
                                    <CustomSearchBox onHitClick={handleSearchClick} />
                                </InstantSearch>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='faqs-wrap wow fadeInUp' data-wow-delay="0.5s">
                    <div className='container'>
                        <div className='lg-title font-2-2em fw-bold text-white mb-4'>Frequently Asked Questions</div>
                        <div className="accordion custom-accordion" id="accordionExample">
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        <em>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum?</em>
                                    </button>
                                </h2>
                                <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        <em>How long does the process typically take?</em>
                                    </button>
                                </h2>
                                <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                        <em>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip?</em>
                                    </button>
                                </h2>
                                <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                        <em>Can I use my vehicle as a trade-in?</em>
                                    </button>
                                </h2>
                                <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                        <em>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip?</em>
                                    </button>
                                </h2>
                                <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='get-instant-wrap'>
                    <div className='container'>
                        <div className='get-instant-box wow fadeInUp' data-wow-delay="0.5s">
                            <div className='lg-title font-2-2em text-center fw-bold text-white'>
                                Get an <span className='text-orange'>Instant Offer</span> for your car now!
                            </div>
                            <div className='mt-4 text-center'>
                                <div className='d-inline-flex align-items-center get-instent-form text-start'>
                                    <InstantSearch indexName="taxonomy_vins" searchClient={searchClient} >
                                        <CustomSearchBox onHitClick={handleSearchClick} />
                                    </InstantSearch>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <ModalLayout open={openAppraiseCar} darkThemeCls='true' modalWidth={857}>
                    <AppraiseCarModal
                        close={closeGetOfferModal}
                        formikRef={formikRef}
                    />
                </ModalLayout> */}
            </section>
        </>
    )
}

export default TradeSellLuxuryCar